import { combineReducers } from "redux";
import { status } from "./status";

/** The combined jupyter state, representing metadata from within the frame. */
export const jupyter = combineReducers({
  status,
});
